import { get as lodashGet } from 'lodash'
import mixpanel from 'mixpanel-browser'
import config from '@/config'

const mixpanelAvailable = config.mixpanel && config.mixpanel.projectToken

function _unregisterBlankProps(propObj) {
  Object.keys(propObj).forEach((key) => {
    if (!propObj[key]) {
      mixpanel.unregister(key)
    }
  })
}

const setUserContext = (user) => {
  // TODO: set the User properties base on the new convention
  const userProps = {
    plan: user.plan,
    email: user.email,
    user_language: lodashGet(user, 'personalInformation.presenterLanguage', 'en'),
  }
  if (mixpanelAvailable) {
    mixpanel.register(userProps)
    _unregisterBlankProps(userProps)
  }
}

const setPresentationContext = (presentation) => {
  // TODO: set the Presentation properties base on the new convention
  const presentationProps = {
    presentation_id: presentation.id,
    presentation_language: lodashGet(presentation, 'language', 'en'),
    // TODO: more props here
  }

  if (mixpanelAvailable) {
    mixpanel.register(presentationProps)
    _unregisterBlankProps(presentationProps)
  }
}

const setSlideContext = (slide) => {
  // TODO: set the Slide properties base on the new convention
  const slideProps = {
    slide_id: slide.id,
    slide_type: slide.type,
    // TODO: more props here
  }
  if (mixpanelAvailable) {
    mixpanel.register(slideProps)
    _unregisterBlankProps(slideProps)
  }
}

const setRouteContext = (route) => {
  const routeProps = {
    page_name: route.name,
  }

  if (mixpanelAvailable) {
    mixpanel.register(routeProps)
    _unregisterBlankProps(routeProps)
  }
}

const setFolderContext = (folder) => {
  const folderProps = {
    folder_id: folder.selectedFolderId,
  }

  if (mixpanelAvailable) {
    mixpanel.register(folderProps)
    _unregisterBlankProps(folderProps)
  }
}

export default {
  mixpanelAvailable,
  setUserContext,
  setPresentationContext,
  setSlideContext,
  setRouteContext,
  setFolderContext,
}
